module.exports = __webpack_public_path__ + "img/power-map-china.ef4e1360.png";